import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { PriceRequestType } from '@markant-platform/cartridge/model';
import { BookingRequestType } from 'data-model';

@Component({
  selector: 'markant-platform-request-type',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoPipe],
  templateUrl: './request-type.component.html',
  styleUrl: './request-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestTypeComponent {
  requestType = input<BookingRequestType | PriceRequestType | undefined>('ORDER_REQUEST');
}
